// Parteibezeichnungen im Vertrag - fuer die Pruefung der Passus.
//
// Gleiche Logik wie parteienImVertrag in api/_lib/verhandlungsPrompt.js (die
// Oberflaeche kann Server-Module nicht einbinden). Anlass (23.09.2026): Bei
// "1 zu 1 einarbeiten" glich die KI "Anlagenbetreiberin" mal an den Vertrag an
// ("Nutzer"), mal nicht. Der Bearbeiter soll das an der Karte sehen, statt es
// im Vertrag zu finden.

const KANDIDATEN = {
  wir: ['Nutzer', 'Anlagenbetreiberin', 'Pächterin', 'Betreiberin'],
  kunde: ['Grundstückseigentümer', 'Verpächter', 'Eigentümer'],
};
const MINDESTENS = 2;

function zaehle(text, wort) {
  const muster = new RegExp(`(^|[^A-Za-zÄÖÜäöüß])${wort}s?(?![A-Za-zÄÖÜäöüß])`, 'g');
  return (String(text || '').match(muster) || []).length;
}

/** Aus HTML lesbarer Text - genug fuer das Zaehlen von Woertern. */
export function textAusHtml(html) {
  return String(html || '')
    .replace(/<(script|style)[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&auml;/g, 'ä').replace(/&ouml;/g, 'ö').replace(/&uuml;/g, 'ü')
    .replace(/&Auml;/g, 'Ä').replace(/&Ouml;/g, 'Ö').replace(/&Uuml;/g, 'Ü')
    .replace(/&szlig;/g, 'ß');
}

/** { wir: 'Nutzer', kunde: 'Grundstückseigentümer' } oder null. */
export function parteienImText(text) {
  const waehle = (liste) => {
    const beste = liste
      .map((wort) => ({ wort, anzahl: zaehle(text, wort) }))
      .sort((a, b) => b.anzahl - a.anzahl)[0];
    return beste.anzahl >= MINDESTENS ? beste.wort : '';
  };
  const wir = waehle(KANDIDATEN.wir);
  const kunde = waehle(KANDIDATEN.kunde);
  return wir && kunde ? { wir, kunde } : null;
}

/**
 * Bezeichnungen im Passus, die im Vertrag anders heissen:
 * [{ steht: 'Anlagenbetreiberin', soll: 'Nutzer' }]. Leer, wenn alles passt
 * oder die Parteien des Vertrags unbekannt sind.
 */
export function abweichendeParteien(passusText, parteien) {
  if (!parteien) return [];
  const abweichend = [];
  for (const [rolle, liste] of Object.entries(KANDIDATEN)) {
    const soll = parteien[rolle];
    for (const wort of liste) {
      if (wort !== soll && zaehle(passusText, wort) > 0) abweichend.push({ steht: wort, soll });
    }
  }
  return abweichend;
}
